import { NotifyHelper } from 'classes/helpers/notify.helper';
import { t } from 'i18next';
import { PitchListOwner } from 'lib_ts/enums/pitch-list.enums';
import { Controller } from 'lib_ts/enums/routing/controllers';
import { AdminPitchListsRoutes } from 'lib_ts/enums/routing/routes/admin-pitch-lists';
import { IServerResponse } from 'lib_ts/interfaces/common/i-server-response';
import {
  IPitchListLink,
  IPitchListPutManyRequest,
} from 'lib_ts/interfaces/pitches';
import { BaseRESTService } from 'services/_base-rest.service';

export class AdminPitchListsService extends BaseRESTService {
  private static instance: AdminPitchListsService;
  static getInstance(): AdminPitchListsService {
    if (!AdminPitchListsService.instance) {
      AdminPitchListsService.instance = new AdminPitchListsService();
    }

    return AdminPitchListsService.instance;
  }

  private constructor() {
    super({
      controller: Controller.AdminPitchLists,
    });
  }

  async restoreLists(
    parent_def: PitchListOwner,
    parent_id: string
  ): Promise<void> {
    return await this.get({
      uri: `${AdminPitchListsRoutes.RestoreLists}/${parent_def}/${parent_id}`,
    })
      .then((result: IServerResponse) => {
        if (!result.success) {
          NotifyHelper.warning({
            message_md: result.error ?? t('common.request-failed-msg'),
          });
        } else {
          NotifyHelper.success({
            message_md:
              'Pitch list restore started, you will be notified upon completion.',
          });
        }
      })
      .catch((reason) => {
        console.error(reason);
        NotifyHelper.error({
          message_md: t('common.request-failed-msg'),
        });
      });
  }

  async updateMany(payload: IPitchListPutManyRequest): Promise<boolean> {
    return await this.put(
      {
        uri: AdminPitchListsRoutes.UpdateMany,
      },
      payload
    );
  }

  async createLink(payload: Partial<IPitchListLink>): Promise<boolean> {
    return await this.post(
      {
        uri: AdminPitchListsRoutes.CreateLink,
      },
      payload
    )
      .then((result: IServerResponse) => {
        if (!result.success) {
          NotifyHelper.warning({
            message_md: result.error ?? t('common.request-failed-msg'),
          });
          return false;
        }

        return true;
      })
      .catch((reason) => {
        console.error(reason);
        NotifyHelper.error({
          message_md: t('common.request-failed-msg'),
        });
        return false;
      });
  }

  async getLinks(listIDs: string[]): Promise<IPitchListLink[]> {
    return await this.post(
      {
        uri: AdminPitchListsRoutes.GetLinks,
      },
      listIDs
    )
      .then((result: IServerResponse) => {
        if (!result.success) {
          NotifyHelper.warning({
            message_md: result.error ?? t('common.request-failed-msg'),
          });
          return [];
        }

        return result.data as IPitchListLink[];
      })
      .catch((reason) => {
        console.error(reason);
        NotifyHelper.error({
          message_md: t('common.request-failed-msg'),
        });
        return [];
      });
  }

  async deleteLinks(linkIDs: string[]): Promise<boolean> {
    return await this.post(
      {
        uri: AdminPitchListsRoutes.DeleteLinks,
      },
      linkIDs
    )
      .then((result: IServerResponse) => {
        if (!result.success) {
          NotifyHelper.warning({
            message_md: result.error ?? t('common.request-failed-msg'),
          });
          return false;
        }
        return true;
      })
      .catch((reason) => {
        console.error(reason);
        NotifyHelper.error({
          message_md: t('common.request-failed-msg'),
        });
        return false;
      });
  }
}
